<template>
    <!-- Page Header-->
    <Header :title="title" :subtitle="subtitle" />
    <!-- Main Content-->
    <main>
        <div class="container px-4 px-lg-5">
            <div class="row gx-4 gx-lg-5 justify-content-center">
                <div class="col-md-10 col-lg-8 col-xl-8">
                    <p>关键词：{{ keyword }}</p>
                    <div class="search-result" v-if="res1" v-for="r in res1">
                        <h2>相关人物-<router-link :to="{ path: '/article', query: { name: r.name } }">{{ r.name
                                }}</router-link>
                        </h2>
                        <p>{{ r.world }}</p>
                        <div v-html="r.summary" />
                    </div>
                    <div class="search-result" v-if="res2" v-for="r in res2">
                        <h2>相关文章-<router-link :to="{ path: '/article', query: { title: r.title } }">{{ r.title
                                }}</router-link></h2>
                        <p>{{ r.subtitle }}</p>
                        <div v-html="r.summary" />
                    </div>
                    <div class="search-result" v-if="res1" v-for="r in res3">
                        <h2>相关人物-<router-link :to="{ path: '/article', query: { name: r.name } }">{{ r.name
                                }}</router-link>
                        </h2>
                        <p>{{ r.world }}</p>
                        <div v-html="r.summary" />
                    </div>
                    <div class="search-result" v-if="res2" v-for="r in res4">
                        <h2>相关文章-<router-link :to="{ path: '/article', query: { title: r.title } }">{{ r.title
                                }}</router-link></h2>
                        <p>{{ r.subtitle }}</p>
                        <div v-html="r.summary" />
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script setup>
import Header from '../components/Header.vue'
import axios from 'axios'
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router';


let route = useRoute();
const keyword = route.query.keyword;

const title = "搜索结果"
const subtitle = "还满意吗…？"
const res1 = ref([]);
const res2 = ref([]);
const res3 = ref([]);
const res4 = ref([]);

const getData = () => {
    var api = "/search.php?keyword=" + keyword;
    axios.get(api).then((res) => {
        res1.value = res.data[0];
        res2.value = res.data[1];
        res3.value = res.data[2];
        res4.value = res.data[3];
    }).catch((err) => {
        console.log(err)
    })
}

onMounted(() => {
    getData()
})
</script>
<style scoped>
p {
    margin: 0.1rem;
}

.search-result {
    border: 1px solid #ccc;
    padding: 1rem;
}
</style>